module.exports = __webpack_public_path__ + "8f5b22430125fc3814648e41660946e3.pdf";